const BASE_URL = import.meta.env.VITE_BASE_URL;

export const getMarketsUrl = `${BASE_URL}/v1/markets`;
